import ifGoldLogo from '../assets/images/iF-Gold.svg';
import ifLogo from '../assets/images/if-logo.svg';
import taipeiGoldLogo from '../assets/images/taipei/TPC_logo_gold.svg';
import taipeiWhiteLogo from '../assets/images/taipei/TPC_logo_white.svg';
import taipeiLogo from '../assets/images/taipei/TPC_logo_color.svg';

const MODE = process.env.REACT_APP_MODE ?? 'if';

export const getLogo = (type = '') => {
  if (MODE === 'taipei') {
    switch (type) {
      case 'gold':
        return taipeiGoldLogo;
      case 'white':
        return taipeiWhiteLogo;
      default:
        return taipeiLogo;
    }
  }

  if (MODE === 'if') {
    switch (type) {
      case 'gold':
        return ifGoldLogo;
      default:
        return ifLogo;
    }
  }
};
